export const BUSINESS_EXPECTATIONS_NOT_MET = {
    economy: {
        en: 'Broader market and state of economy',
        es: 'Mercado más amplio y estado de la economía'
    },
    expenses: {
        en: 'Underestimated expenses',
        es: 'Gastos subestimados'
    },
    market: {
        en: 'Market took longer to develop; fewer customers than anticipated',
        es: 'El mercado tardó más en desarrollarse; menos clientes de lo previsto'
    },
    slow: {
        en: 'Business took more time than expected',
        es: 'El negocio tardó más de lo esperado'
    },
    capital: {
        en: 'Business needed more capital than expected',
        es: 'El negocio necesitó más capital del esperado'
    },
    personal: {
        en: 'Personal issues or illness of owner or family members',
        es: 'Problemas personales o enfermedad del propietario o miembros de la familia'
    },
    other: {
        en: 'Other',
        es: 'Otro'
    },
    idk: {
        en: "Don't Know",
        es: 'No sé'
    },
    na: {
        en: 'N/A',
        es: 'N/A'
    },
    dna: {
        en: 'Prefer Not to Answer',
        es: 'Prefiero no responder'
    }
} as Record<string, { en: string; es: string }>;
